export enum SwipeDirection {
  BACK = 2,
  FORWARD = 4,
}
